import * as React from 'react';
const SvgCodeCircle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
        <circle cx={11} cy={11} r={11} fill="currentColor" />
        <path
            d="M7 14l-3-3 3-3M15 8l3 3-3 3M12 6l-2 10"
            stroke="#fff"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SvgCodeCircle;
